import React, { useRef } from "react";
import ContactSection from "../common/ContactAs";
import Footer from "../common/Footer";
import NavigationBar from "../common/NavigationBar";
import OurServices from "../components/OurServices";
import OurPricing from "../components/OurPricing";
import background from "../assets/bg-shape-1.png";

const NewServices = () => {
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const offersRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="landing-container">
    <NavigationBar />
    <div className="Full-Service">
        <div className="background-image">
          <img src={background} alt="Background" />
        </div>
        <div className="content">
          <h2>Our Services</h2>
          <h4>Web design that leaves an impression.</h4>
        </div>
      </div>
      <OurServices />
      <OurPricing />
      <section ref={contactRef}>
        <ContactSection
          scrollToSection={scrollToSection}
          homeRef={homeRef}
          aboutRef={aboutRef}
          servicesRef={servicesRef}
          contactRef={contactRef}
        />
      </section>
      <Footer />
    </div>
  );
};

export default NewServices;
